import {
  HashRouter,
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import ResetPassword from "./components/Auth/ResetPassword";
import ResetSuccessfully from "./components/Auth/ResetSuccessfully";
import DashboardInnerPage from "./Admin/DashboardInnerPage";
import AddUser from "./Admin/UserSection/AddUser";
import AllUsers from "./Admin/UserSection/AllUsers";
import OverviewInnerPage from "./Admin/ProfileOverview/OverviewInnerPage";
import Sales from "./Admin/SalesInnerPage";
import SettingInner from "./Admin/SettingInner";
import "./App.css";
import { useAuth } from "./AuthProvider";
import { LoginProvider } from "./components/Auth/context/LoginProvider";
import { useEffect } from "react";
import { ProfileProvider } from "./Admin/ProfileOverview/context/ProfileProvider";
import { UserProvider } from "./Admin/UserSection/context/UserProvider";
import AllProduct from "./Admin/ProductService/AllProduct";
import NewProduct from "./Admin/ProductService/NewProduct";
import { ProductProvider } from "./Admin/ProductService/context/useProductContext";
import AllCategory from "./Admin/ProductService/AllCategory";
import EditProduct from "./Admin/ProductService/EditProduct";
import { UtilitiesProvider } from "./Admin/ProductService/context/UtitlitiesContext";
import AddUtility from "./Admin/ProductService/Utitilities/AddUtility";

function ProtectedRoute({ children }) {
  const { isAuthenticated, setIsAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setIsAuthenticated(false); // Update authentication state
        navigate("/login", { state: { from: location }, replace: true });
      } else {
        setIsAuthenticated(true);
      }
    };

    // Listen for changes in token or path
    checkToken();
  }, [navigate, setIsAuthenticated]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Or a spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <Routes>
                  <Route path="dashboard" element={<DashboardInnerPage />} />
                  <Route path="sales" element={<Sales />} />
                  <Route
                    path="overview"
                    element={
                      <ProfileProvider>
                        <OverviewInnerPage />
                      </ProfileProvider>
                    }
                  />
                  <Route
                    path="allusers"
                    element={
                      <UserProvider>
                        <AllUsers />
                      </UserProvider>
                    }
                  />
                  <Route
                    path="adduser"
                    element={
                      <UserProvider>
                        <AddUser />
                      </UserProvider>
                    }
                  />
                  <Route path="setting" element={<SettingInner />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route
                    path="/allProduct"
                    element={
                      <ProductProvider>
                        <AllProduct />
                      </ProductProvider>
                    }
                  />
                  <Route
                    path="/addProduct"
                    element={
                      <ProductProvider>
                        <NewProduct />
                      </ProductProvider>
                    }
                  />
                  <Route
                    path="/editProduct"
                    element={
                      <ProductProvider>
                        <EditProduct />
                      </ProductProvider>
                    }
                  />
                  <Route
                    path="/allCategory"
                    element={
                      <ProductProvider>
                        <AllCategory />
                      </ProductProvider>
                    }
                  />
                  <Route
                    path="/addUtilities"
                    element={
                      <UtilitiesProvider>
                        <AddUtility />
                      </UtilitiesProvider>
                    }
                  />
                </Routes>
              </ProtectedRoute>
            }
          />
          <Route
            path="/login"
            element={
              <LoginProvider>
                <Login />
              </LoginProvider>
            }
          />
          <Route path="/signup" element={<Signup />} />

          <Route path="/reset-successfully" element={<ResetSuccessfully />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
